import { render, staticRenderFns } from "./OnboardingNavigation.vue?vue&type=template&id=6f763c26&"
import script from "./OnboardingNavigation.vue?vue&type=script&lang=ts&"
export * from "./OnboardingNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports